import PigletPaymentSlipApi from "@/api/piglet/pigletPaymentSlipApi";

export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async fetch({dispatch}, storageIds) {
      try {
        const response = await PigletPaymentSlipApi.fetch(storageIds);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, { root: true });
        return await Promise.reject(error);
      }
    },
    async fetchNumbers({dispatch}, form) {
      try {
        const response = await PigletPaymentSlipApi.fetchNumbers(form);
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error, { root: true });
        return await Promise.reject(error);
      }
    }
  }
}
